import styled from "styled-components";

const Container = styled.div`
  margin: 10px auto;

  .names {
    display: flex;
    justify-content: space-between;
  }
`;

const Label = styled.span`
  font-weight: ${({ isHighlighted }) => (isHighlighted ? `700` : `500`)};
`;

const StyledSlider = styled.input`
  cursor: pointer;
  width: 100%;

  /* Override base input CSS styles */
  &[type="range"] {
    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
    width: 100%; /* Specific width is required for Firefox. */
    background: transparent; /* Otherwise white in Chrome */

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
    }

    &:focus {
      outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
    }

    &::-ms-track {
      width: 100%;
      cursor: pointer;

      /* Hides the slider so custom styles can be added */
      background: transparent;
      border-color: transparent;
      color: transparent;
    }
  }

  /* Override thumb styles */
  &[type="range"] {
    /* Special styling for WebKit/Blink */
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: 24px;
      width: 24px;
      border: 8px solid #fff;
      border-radius: 50%;
      background: transparent;
      cursor: pointer;
      margin-top: -8px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d; /* Add cool effects to your sliders! */
    }

    /* All the same stuff for Firefox */
    ::-moz-range-thumb {
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
      height: 10px;
      width: 10px;
      border: 8px solid #fff;
      border-radius: 50%;
      background: transparent;
      cursor: pointer;
    }

    /* All the same stuff for IE */
    &::-ms-thumb {
      box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
      height: 10px;
      width: 10px;
      border-radius: 50%;
      background: transparent;
      cursor: pointer;
    }
  }

  /* Custom track styles */
  &[type="range"] {
    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 8.4px;
      cursor: pointer;
      border-radius: 1.3px;
    }

    &::-moz-range-track {
      width: 100%;
      height: 8.4px;
      cursor: pointer;
      border-radius: 1.3px;
    }

    &::-ms-track {
      width: 100%;
      height: 8.4px;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      border-width: 16px 0;
      color: transparent;
    }
    &::-ms-fill-lower {
      border-radius: 2.6px;
    }
    &::-ms-fill-upper {
      border-radius: 2.6px;
    }
  }

  ${({ colorLeft, colorRight }) => `
    &[type="range"] {
      &::-webkit-slider-runnable-track {
        background: linear-gradient(90deg, ${colorLeft} 0%, ${colorRight} 100%);
      }

      &:focus::-webkit-slider-runnable-track {
        background: linear-gradient(90deg, ${colorLeft} 0%, ${colorRight} 100%);
      }

      &::-moz-range-track {
        background: linear-gradient(90deg, ${colorLeft} 0%, ${colorRight} 100%);
      }

      &::-ms-fill-lower {
        background: #2a6495;
      }
      &:focus::-ms-fill-lower {
        background: linear-gradient(90deg, ${colorLeft} 0%, ${colorRight} 100%);
      }
      &::-ms-fill-upper {
        background: linear-gradient(90deg, ${colorLeft} 0%, ${colorRight} 100%);
      }
      &:focus::-ms-fill-upper {
        background: linear-gradient(90deg, ${colorLeft} 0%, ${colorRight} 100%);
      }

    }
  `}
`;

const Slider = ({
  nameLeft = "",
  nameRight = "",
  colorLeft,
  colorRight,
  min = 0,
  max = 1,
  value = 0.5,
  setValue,
  step = 0.01,
}) => {
  const isHighlightedLeft = (val) => val < max / 2;

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Container className="slider-container">
      <div className="names">
        <Label className="name-left" isHighlighted={isHighlightedLeft(value)}>
          {nameLeft}
        </Label>
        <Label className="name-right" isHighlighted={!isHighlightedLeft(value)}>
          {nameRight}
        </Label>
      </div>
      <StyledSlider
        type="range"
        onChange={handleChange}
        className="slider"
        {...{ min, max, step, value, colorLeft, colorRight }}
      />
    </Container>
  );
};

export default Slider;
